
import { AddMethodSettingsScreenNavigationProps } from "./types"
import React from "react"
import AddMethodSettings from "./add-method-settings-screen"
import { PageRoot } from "~screens/page-root"


// 添加方式设置
const AddMethodSettingsScreen: React.FC<AddMethodSettingsScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <AddMethodSettings route={route}/>
    </PageRoot>
  )
}

export default AddMethodSettingsScreen
